export default "__VITE_ASSET__BAZtSq9b__"